export const STUDENTREPORT_GET_MULTIPLE =  "STUDENTREPORT_GET_MULTIPLE"
export const STUDENTREPORT_GET_DROPDOWNS =  "STUDENTREPORT_GET_DROPDOWNS"
export const STUDENTREPORT_GET_ONE =  "STUDENTREPORT_GET_ONE"
export const STUDENTREPORT_REGISTER_SUCCESS =  "STUDENTREPORT_REGISTER_SUCCESS"
export const STUDENTREPORT_REGISTER_FAIL =  "STUDENTREPORT_REGISTER_FAIL"
export const STUDENTREPORT_LOADING =  "STUDENTREPORT_LOADING"
export const STUDENTREPORT_LOADING_ERROR =  "STUDENTREPORT_LOADING_ERROR"
export const STUDENTREPORT_ACTIVATE_FAIL =  "STUDENTREPORT_ACTIVATE_FAIL"
export const STUDENTREPORT_ACTIVATE_SUCCESS =  "STUDENTREPORT_ACTIVATE_SUCCESS"
export const STUDENTREPORT_UPDATE_SUCCESS =  "STUDENTREPORT_UPDATE_SUCCESS"
export const STUDENTREPORT_UPDATE_FAIL =  "STUDENTREPORT_UPDATE_FAIL"
export const STUDENTREPORT_DELETE_SUCCESS =  "STUDENTREPORT_DELETE_SUCCESS"
export const STUDENTREPORT_DELETE_FAIL =  "STUDENTREPORT_DELETE_FAIL"
export const STUDENTREPORT_EDIT =  "STUDENTREPORT_EDIT"